import { Component, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { GetDetallesEmpresaResponse } from 'src/app/content/admin/responses/get-detalles-empresa-response';
import { EmpresaService } from 'src/app/content/empresa/services/empresa.service';
import { UserRole } from 'src/app/_models/userEnum';
import { AuthService } from 'src/app/_services/auth.service';
import { AuthUser } from '../administrador/AuthUser';
import { companyLoginResponse } from '../models/entities/company-login-response';
import { companyLoginRequest } from '../models/requests/company-login';
import { LoginCompanyService } from '../services/login-company.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-empresa',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.css']
})
export class LoginEmpresaComponent {
loading = false;
submitted = false;
returnUrl: string;
isPageLoaded = false;
isProcessing = false;

companyData : GetDetallesEmpresaResponse;

loginCompanyForm: FormGroup;
constructor(private fb: FormBuilder,
            private loginService : LoginCompanyService,
            private router: Router,
            private authService : AuthService,
            private toastr : ToastrService,
            private empresaService : EmpresaService,
            private renderer : Renderer2,
            private recaptchaV3Service: ReCaptchaV3Service){}


ngOnInit() 
{
  // arreglar vista
  this.renderer.removeClass(document.body, 'vertical-overlay-menu');
  this.renderer.removeClass(document.body, 'bg-full-screen-image');
  this.renderer.removeClass(document.body, 'vertical-menu-modern');
  this.renderer.removeClass(document.body, 'fixed-navbar');    
  // arreglar vista
    this.initLoginForm();
    this.isPageLoaded=true;
    const currentUser = this.authService.getUser() as AuthUser;
    if(currentUser) {
      if(currentUser.role===UserRole.Graduated)
      {
        this.router.navigate(['egresado/']);
      }
      if(currentUser.role===UserRole.Company)
      {
        this.router.navigate(['empresa/']);
      }
      if(currentUser.role===UserRole.Professor)
      {
        this.router.navigate(['docente/']);
      }
      if(currentUser.role===UserRole.Admin)
      {
        this.router.navigate(['onlyadminaccess/dashboard/']);
      }
    } else {
      this.isPageLoaded = true;
    }
  }

initLoginForm() {
  this.loginCompanyForm = this.fb.group({
  usuario: ['userEmpresa123', Validators.required],
  password: ['hire_me_please', Validators.required],
  rememberMe: false
  });
}

back()
  {
    this.router.navigate(['/portal-empresa']);
  }

  async tryLogin()
  {
    this.submitted = true;
    if (this.loginCompanyForm.invalid)
    {
      this.toastr.warning('Verifica los datos.', 'Advertencia', {
        tapToDismiss: false
      });
      return;
    }
    this.isProcessing=true;
    this.recaptchaV3Service.execute('loginCompany')
        .subscribe((token) => this.handleToken(token));
  }

  async handleToken(token: string): Promise<void> {
    let data : companyLoginRequest = new companyLoginRequest();
    data.usuario=this.f.usuario.value;
    data.password=this.f.password.value;
    data.recaptchaToken=token;
      this.loginService.loginCompany(data).subscribe(async response=>
      {
        if(!response.success)
        {
          this.toastr.error('No se encontró un usuario con esas credenciales', 'Error', {
            toastClass: 'ngx-toastr toast-error'
          });
          this.isProcessing=false;
          return;
        }
        this.saveUserStorage(response);
        if(!await this.LoadCompanyInfo(response.idUsuario))
        {
          this.toastr.error('Error al cargar los datos','error');
          return;
        }
        this.isProcessing=false;
        let returnUrl = 'empresa/';
        if (this.returnUrl) {
          returnUrl = this.returnUrl;
        }
        this.router.navigate([returnUrl]);
      }),
      (error=>{
          this.submitted=false;
          this.isProcessing=false;
        });  
  }

  async LoadCompanyInfo(idUsuario) : Promise<Boolean>
  {
    try 
    {
      this.companyData = await firstValueFrom(this.empresaService.getDetallesEmpresa(idUsuario));
      if(this.companyData)
      {
        this.authService.saveComp(this.companyData);
        return true;
      }
    } 
    catch (error) {
      return false;
      // manejar el error
    }
      return false;
  }

  get f() {
    return this.loginCompanyForm.controls;
  }

  saveUserStorage(res: companyLoginResponse) {
    if (res) {
      const authUser: AuthUser = {
        role:UserRole.Company,
        token:res.token
      };
      this.authService.saveUser(authUser);
    } 
  }
}
